import React, { useState } from "react";
import { Footer, Navbar } from "../components";
import axios from "axios";
import configData from "../config.json";
import { useNavigate } from "react-router-dom"

const ContactPage = () => {
  const [inputData,setInputData]=useState({name:'',email:'',mobile:'',content:''})
  const navigate=useNavigate();
  const handleInput=(e)=>{
    const {name,value}=e.target;
    setInputData({...inputData,[name]:value});
  }
  const handleSubmit=async(e)=>{
    e.preventDefault();
    const allinputData={name:inputData.name,email:inputData.email,mobile:inputData.mobile,content:inputData.content}
    // console.log(allinputData);
    let res=await axios.post(configData.SERVER_URL+'/customerMsgEntry',allinputData);
    if(res.status===200){
      setTimeout(()=>{
        navigate('/');
      },2000)
      alert('Successfully Inserted');
    } else{
      alert('Insertion Fail');
    }
  }

  return (
    <>
      <Navbar />
      <div className="container my-3 py-3">
        <h1 className="text-center" style={{color:'green'}}>Contact Us</h1>
        <hr />
        <div class="row my-4 h-100">
          <div className="col-md-4 col-lg-4 col-sm-8 mx-auto">
            <form onSubmit={handleSubmit}>
              <div class="form my-3">
                <label for="Name">Name</label>
                <input type="text" class="form-control" name="name" id="name" placeholder="Enter name"
                value={inputData.name} onChange={handleInput} required/>
              </div>
              <div class="form my-3">
                <label for="Name">Mobile</label>
                <input type="text" class="form-control" name="mobile" id="mobile" placeholder="Enter mobile No"
                value={inputData.mobile} onChange={handleInput} required/>
              </div>
              <div class="form my-3">
                <label for="Email">Email</label>
                <input type="email" class="form-control" name="email" id="email" placeholder="Enter email"
                value={inputData.email} onChange={handleInput} required/>
              </div>
              <div class="form  my-3">
                <label for="Content">Message</label>
                <textarea rows={5} class="form-control" name="content" id="content" placeholder="Enter message"
                value={inputData.content} onChange={handleInput} required/>
              </div>
              <div className="text-center">
                <button class="my-2 px-4 mx-auto btn btn-info" type="submit" >Send</button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default ContactPage;
